import React, { useEffect } from 'react';
import { Formik, FormikProps } from 'formik';
import { Row } from 'reactstrap';
import {
  GetProductByIdFromAPI,
  ProductFormDetailsInterface,
} from 'types/productTypes';
import { useSelector } from 'react-redux';
import ProductGeneralInfo from 'pages/Products/ProductManagement/ProductGeneralInfo';
import ProductPriceInfo from 'pages/Products/ProductManagement/ProductPriceInfo';
import ProductStockInfo from 'pages/Products/ProductManagement/ProductStockInfo';
import { RootState } from 'slices';
import { Dispatch } from 'redux';
import { ProductValidationSchemaType } from './ValidationSchema';
import FormActionButtons from 'pages/Products/ProductManagement/FormActionButtons';
import ProductOptions from 'pages/Products/ProductManagement/ProductOptions';

const ProductForm = ({
  dispatch,
  initialValues,
  validationSchema,
  submitProductForm,
  formikRef,
  selectProduct,
  searchInputRef,
  toggleModal,
  closeModal,
}: {
  dispatch: Dispatch;
  initialValues:
    | ProductFormDetailsInterface
    | Partial<ProductFormDetailsInterface>;
  validationSchema: ProductValidationSchemaType;
  submitProductForm: (values: ProductFormDetailsInterface) => Promise<void>;
  formikRef: React.RefObject<FormikProps<ProductFormDetailsInterface>>;
  selectProduct: (
    product: GetProductByIdFromAPI,
    formik: FormikProps<ProductFormDetailsInterface>
  ) => void;
  searchInputRef: React.RefObject<HTMLInputElement>;
  toggleModal: (index?: number | null) => void;
  closeModal: () => void;
}) => {
  const productFormState = useSelector((state: RootState) => state.Product);
  const { isEdit, countSubmit } = productFormState.form;

  useEffect(() => {
    if (formikRef.current && formikRef.current.errors) {
      const errorKeys = Object.keys(formikRef.current.errors);
      if (errorKeys.length > 0) {
        const firstErrorField = document.querySelector(
          `[name="${errorKeys[0]}"]`
        ) as HTMLInputElement | null;
        // console.log(firstErrorField);

        if (
          firstErrorField !== null &&
          firstErrorField.type === 'hidden' &&
          firstErrorField.name === 'category'
        ) {
          const relatedElement = document.querySelector(
            '#react-select-2-input'
          ) as HTMLInputElement | null;

          if (relatedElement) {
            relatedElement.focus();
          }
        } else {
          if (firstErrorField) firstErrorField.focus();
        }
      }
    }
  }, [formikRef, countSubmit]);

  return (
    <Formik<ProductFormDetailsInterface>
      initialValues={initialValues as ProductFormDetailsInterface}
      validationSchema={validationSchema}
      onSubmit={async (values: ProductFormDetailsInterface) => {
        await submitProductForm(values);
      }}
      enableReinitialize={isEdit ? false : true}
      innerRef={formikRef}
    >
      {(formik) => (
        <form className="" onSubmit={formik.handleSubmit} noValidate>
          <Row>
            <ProductGeneralInfo dispatch={dispatch} formik={formik} />
          </Row>

          <Row>
            <ProductPriceInfo
              isEdit={isEdit}
              dispatch={dispatch}
              formik={formik}
            />
          </Row>
          <Row>
            <ProductOptions
              _isEdit={isEdit}
              _dispatch={dispatch}
              formik={formik}
            />
          </Row>

          <Row>
            <ProductStockInfo
              dispatch={dispatch}
              formik={formik}
              toggleModal={toggleModal}
              closeModal={closeModal}
              selectProduct={selectProduct}
              searchInputRef={searchInputRef}
            />
          </Row>
          <FormActionButtons dispatch={dispatch} formik={formik} />
        </form>
      )}
    </Formik>
  );
};

export default ProductForm;
